import { FC, useEffect } from 'react';

import { useAccountMinorToAdultMigrateMutation, useActivateAccountMutation } from 'store/signup/signupAPI';

import { LoadingCard, MainContainer } from '@britishcouncil/react-solas-ors3';

import { ActivationSuccess, OnlyMigrationSuccess } from './ActivationSuccess';
import { ActivatonFailed, OnlyMigrationFailed } from './ActivationFailed';

export const SimpleActivation: FC<{
  email: string;
  token: string;
}> = (params) => {
  const [activate, activateData] = useActivateAccountMutation();
  
  useEffect(() => {
      activate({email: params.email, token: params.token});
  }, [activate, params.email, params.token]);
  
  return (
    <MainContainer>
      {activateData.isLoading && <LoadingCard title="Verification">One second, please</LoadingCard>}
      {activateData.isError && <ActivatonFailed />}
      {activateData.isSuccess && <ActivationSuccess />}
    </MainContainer>
  );
};

export const OnlyCompleteMigration = ({ candidateId }: { candidateId: number }) => {
  const [migrateMinorToAdult, migrateData] = useAccountMinorToAdultMigrateMutation();

  useEffect(() => {
    migrateMinorToAdult(candidateId);
  }, [candidateId, migrateMinorToAdult]);

  return (
    <MainContainer>
      {migrateData.isLoading && <LoadingCard title="Verification">One second, please</LoadingCard>}
      {migrateData.isError && <OnlyMigrationFailed />}
      {migrateData.isSuccess && <OnlyMigrationSuccess />}
    </MainContainer>
  );
};
